var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ArrowMaximize component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArrowMaximize extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.79 2.00145C22.79 1.80145 22.72 1.60145 22.57 1.45145C22.47 1.35145 22.36 1.29145 22.24 1.26145C22.19 1.25145 22.13 1.24145 22.08 1.23145C22.07 1.23145 22.06 1.23145 22.04 1.23145H15.8C15.39 1.23145 15.05 1.57145 15.05 1.98145C15.05 2.39145 15.39 2.73145 15.8 2.73145H20.23L13.71 9.25145C13.42 9.54145 13.42 10.0214 13.71 10.3114C14 10.6014 14.48 10.6014 14.77 10.3114L21.29 3.79145V8.22145C21.29 8.63145 21.63 8.97145 22.04 8.97145C22.45 8.97145 22.79 8.63145 22.79 8.22145V2.00145V2.00145ZM3.56 2.73145H7.99C8.4 2.73145 8.74 2.39145 8.74 1.98145C8.74 1.57145 8.4 1.23145 7.99 1.23145H1.75C1.56 1.23145 1.37 1.30145 1.22 1.45145C1.15 1.52145 1.09 1.60145 1.06 1.69145C1.02 1.78145 1 1.88145 1 1.98145V8.22145C1 8.63145 1.34 8.97145 1.75 8.97145C2.16 8.97145 2.5 8.63145 2.5 8.22145V3.79145L9.02 10.3114C9.31 10.6014 9.79 10.6014 10.08 10.3114C10.37 10.0214 10.37 9.54145 10.08 9.25145L3.56 2.73145ZM13.71 13.9414C14 13.6514 14.48 13.6514 14.77 13.9414L21.29 20.4614V16.0314C21.29 15.6214 21.63 15.2814 22.04 15.2814C22.45 15.2814 22.79 15.6214 22.79 16.0314V22.2614C22.79 22.4614 22.72 22.6614 22.57 22.8114C22.42 22.9614 22.22 23.0314 22.02 23.0314H15.79C15.38 23.0314 15.04 22.6914 15.04 22.2814C15.04 21.8714 15.38 21.5314 15.79 21.5314H20.22L13.7 15.0114C13.41 14.7214 13.41 14.2414 13.7 13.9514L13.71 13.9414ZM10.09 13.9414C10.38 14.2314 10.38 14.7114 10.09 15.0014L3.57 21.5214H7.99C8.4 21.5214 8.74 21.8614 8.74 22.2714C8.74 22.6814 8.4 23.0214 7.99 23.0214H1.77C1.57 23.0214 1.37 22.9514 1.22 22.8014C1.12 22.7014 1.06 22.5914 1.03 22.4714C1.02 22.4214 1.01 22.3614 1 22.3114C1 22.3014 1 22.2914 1 22.2714V16.0314C1 15.6214 1.34 15.2814 1.75 15.2814C2.16 15.2814 2.5 15.6214 2.5 16.0314V20.4614L9.02 13.9414C9.31 13.6514 9.79 13.6514 10.08 13.9414H10.09Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArrowMaximize.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowMaximize.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowMaximize.prototype, "size", void 0);
if (customElements.get('cat-icon-arrow-maximize') === undefined) {
    customElements.define('cat-icon-arrow-maximize', BlocksIconArrowMaximize);
}
